export default {
    navigationBarTitleText: '福昕智装'
};
